<template>
  <div class="apiDocument">
    <div class="body">
      <el-container>
        <el-aside>
          <div class="dev_title">
            <span>
              全部文档
            </span>
            <router-link :to="{name: 'document'}" style="font-size: 12px;color: #999; float: right;">切换老文档</router-link>
          </div>
          <el-menu
            :default-active="activeMenu"
            class="el-menu-vertical-demo"
            @select="handleSelect"
          >
            <el-menu-item index="introduce">平台简介</el-menu-item>
            <el-submenu index="argument">
              <template slot="title">
                <span>政策规范</span>
              </template>
              <el-menu-item index="agreement">开发者协议</el-menu-item>
            </el-submenu>
            <el-submenu index="document">
              <template slot="title">
                <span>API文档 </span>
              </template>
              <el-submenu index="api-base">
                <template slot="title">
                  <span>基础数据API</span>
                </template>
                <el-menu-item index="api-stageList">获取学段</el-menu-item>
                <el-menu-item index="api-gradeList">获取年级</el-menu-item>
                <el-menu-item index="api-subjectList">获取学科</el-menu-item>
                <el-menu-item index="api-provinceList">获取地区</el-menu-item>
              </el-submenu>
              <el-submenu index="api-doc">
                <template slot="title">
                  <span>文档资源</span>
                </template>
                <el-menu-item index="api-docColumnList">获取文档栏目</el-menu-item>
                <el-menu-item index="api-docTypeList">获取文档类型</el-menu-item>
                <el-menu-item index="api-docVersionList">获取文档版本</el-menu-item>
                <el-menu-item index="api-docTextbookList">获取文档册别</el-menu-item>
                <el-menu-item index="api-docBooknodeList">获取文档章节</el-menu-item>
                <el-menu-item index="api-docKnowledgeList"> 获取文档知识点</el-menu-item>
                <el-menu-item index="api-docGetList">获取文档列表</el-menu-item>
                <el-menu-item index="api-docGetInfo">查看文档详情</el-menu-item>
                <el-menu-item index="api-docGetPreview">预览文档图片</el-menu-item>
              </el-submenu>
              <el-submenu index="paper">
                <template slot="title"><span>试卷资源</span></template>
                <el-menu-item index="api-paperColumnList">获取试卷栏目</el-menu-item>
                <el-menu-item index="api-paperTypeList">获取试卷类型</el-menu-item>
                <el-menu-item index="api-paperVersionList">获取试卷版本</el-menu-item>
                <el-menu-item index="api-paperTextbookList">获取试卷册别</el-menu-item>
                <el-menu-item index="api-paperBookNodeList">获取试卷章节</el-menu-item>
                <el-menu-item index="api-paperknowledgeList">获取试卷知识点</el-menu-item>
                <el-menu-item index="api-paperGetList">获取试卷列表</el-menu-item>
                <el-menu-item index="api-paperGetInfo">查看试卷详情</el-menu-item>
                <el-menu-item index="api-paperGetPreview">预览试卷图片</el-menu-item>
              </el-submenu>
              <!-- <el-submenu index="question">
                <template slot="title"><span>试题资源</span></template>
                <el-menu-item index="api-questionTypeList">获取试题题型</el-menu-item>
                <el-menu-item index="api-questionDifficultList">获取试题难度</el-menu-item>
                <el-menu-item index="api-questionVersionList">获取试题版本</el-menu-item >
                <el-menu-item index="api-questionTextbookList">获取试题册别</el-menu-item>
                <el-menu-item index="api-questionBooknodeList">获取试题章节</el-menu-item>
                <el-menu-item index="api-questionKnowledgeList">获取试题知识点</el-menu-item>
                <el-menu-item index="api-questionGetList">获取试题列表</el-menu-item>
                <el-menu-item index="api-questionGetInfo">查看试题详情</el-menu-item>
              </el-submenu> -->
              <el-submenu index="questionV4">
                <template slot="title"><span>试题资源</span></template>
                <el-menu-item index="api-questionV4TypeList">获取试题题型</el-menu-item>
                <el-menu-item index="api-questionV4DifficultList">获取试题难度</el-menu-item>
                <el-menu-item index="api-questionV4VersionList">获取试题版本</el-menu-item >
                <el-menu-item index="api-questionV4TextbookList">获取试题册别</el-menu-item>
                <el-menu-item index="api-questionV4BooknodeList">获取试题章节</el-menu-item>
                <el-menu-item index="api-questionV4KnowledgeList">获取试题知识点</el-menu-item>
                <el-menu-item index="api-questionV4TagTypeList">获取学科特色标签类型</el-menu-item>
                <el-menu-item index="api-questionV4TagList">获取学科特色标签</el-menu-item>
                <el-menu-item index="api-questionV4PaperTypeList">获取试题来源</el-menu-item>
                <el-menu-item index="api-questionV4GetList">获取试题列表</el-menu-item>
                <el-menu-item index="api-questionV4GetInfo">查看试题详情</el-menu-item>
              </el-submenu>
              <el-submenu index="album">
                <template slot="title"><span>专辑资源</span></template>
                <el-menu-item index="api-albumTypeList">获取类别</el-menu-item>
                <el-menu-item index="api-albumVersionList">获取版本</el-menu-item>
                <el-menu-item index="api-albumTextbookList">获取册别</el-menu-item>
                <el-menu-item index="api-albumReviewSectionList">获取复习段</el-menu-item>
                <el-menu-item index="api-albumCatalogList">获取资源类型</el-menu-item>
                <el-menu-item index="api-albumTopicList">获取专题列表</el-menu-item>
                <el-menu-item index="api-albumTopicAlbum">获取专题下专辑</el-menu-item>
                <el-menu-item index="api-albumTopicInfo">获取专题基本信息</el-menu-item>
                <el-menu-item index="api-albumAlbumList">获取专辑列表</el-menu-item>
                <el-menu-item index="api-albumAlbumDoc">获取专辑下文档</el-menu-item>
                <el-menu-item index="api-albumAlbumInfo">获取专辑基本信息</el-menu-item>
                <el-menu-item index="api-albumAlbumPreview">专辑文档预览</el-menu-item>
                <el-menu-item index="api-albumAlbumDownload">专辑文档下载</el-menu-item>
              </el-submenu>
              <el-submenu index="garden">
                <template slot="title"><span>教改园地</span></template>
                <el-menu-item index="api-gardenColumnList">获取所有栏目</el-menu-item>
                <el-menu-item index="api-gardenTopicList">获取栏目下专题</el-menu-item>
                <el-menu-item index="api-gardenTopicInfo">获取专题基本信息</el-menu-item>
                <el-menu-item index="api-gardenVersionList">获取专题下专辑版本</el-menu-item>
                <el-menu-item index="api-gardenTextbookList">获取专题下专辑册别</el-menu-item>
                <el-menu-item index="api-gardenProvinceList">获取专题下专辑地区</el-menu-item>
                <el-menu-item index="api-gardenDifficultyList">获取专题下专辑难易</el-menu-item>
                <el-menu-item index="api-gardenAlbumList">获取专题下专辑列表</el-menu-item>
                <el-menu-item index="api-gardenAlbumInfo">获取专辑详情</el-menu-item>
                <el-menu-item index="api-gardenAlbumDoc">获取专辑文档</el-menu-item>
                <el-menu-item index="api-gardenAlbumPreview">专辑文档预览</el-menu-item>
                <el-menu-item index="api-gardenAlbumDownload">专辑文档下载</el-menu-item>
              </el-submenu>
              <el-submenu index="research">
                <template slot="title"><span>教师研修(微课)</span></template>
                <el-menu-item index="api-researchTopicList">获取系列下所有主题</el-menu-item>
                <el-menu-item index="api-researchTopicDetail">获取主题详情和主题课程</el-menu-item>
                <el-menu-item index="api-researchCouseDetail">获取课程详情</el-menu-item>
                <el-menu-item index="api-researchCourseTeacherDetail">获取课程名师详情</el-menu-item>
                <el-menu-item index="api-researchCourseNodes">获取课程下的目录</el-menu-item>
                <el-menu-item index="api-researchCourseVideos">获取课程目录下的视频列表</el-menu-item>
                <el-menu-item index="api-researchVideoAddress">获取视频完整播放链接</el-menu-item>
              </el-submenu>
              <!-- <el-submenu index="microVideo">
                <template slot="title"><span>视频资源</span></template>
                <el-menu-item index="api-microSubjectList">根据通用学段获取微课学科列表</el-menu-item>
                <el-menu-item index="api-microKnowList">根据微课学科获取微课知识点</el-menu-item>
                <el-menu-item index="api-microGetList">获取微课视频列表</el-menu-item>
                <el-menu-item index="api-microPlayCode">获取微课播放授权码</el-menu-item>
              </el-submenu> -->
            </el-submenu>
            <el-menu-item index="formulaEX">试题公式显示示例</el-menu-item>
            <el-menu-item index="aliyunVod">视频播放实例</el-menu-item>
            <el-menu-item index="errorCode">错误码</el-menu-item>
            <el-menu-item index="autograph">签名算法</el-menu-item>
          </el-menu>
        </el-aside>
        <el-main v-if="isdebug">
          <el-tabs
            style="margin-top: 30px;"
            :tab-position="tabPosition"
            v-model="activeName"
          >
            <el-tab-pane label="文档" name="document">
              <describe
                :mainHtml="mainHtml"
              >
              </describe>
            </el-tab-pane>
            <el-tab-pane label="调试" name="debug" >
              <debug
                :keyName="keyName"
              >
              </debug>
            </el-tab-pane>
          </el-tabs>
        </el-main>
        <el-main v-else>
          <describe
            :mainHtml="mainHtml"
          >
          </describe>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script type="text/babel">
import { data } from "./data";
import { apiData } from "./apiData";
import describe from './components/describe.vue';
import debug from './components/debug.vue';

export default {
  components: {
    describe,
    debug
  },
  data: function () {
    return {
      activeName: "document",
      isdebug: false,
      tabPosition: "left",
      mainHtml: data.introduce,
      activeMenu: "introduce",
      keyName: "introduce",
    };
  },
  name: "document",
  mounted () {
    if (this.$route.query.activeMenu) {
      this.activeMenu = this.$route.query.activeMenu;
      this.handleSelect(this.activeMenu)
    }
  },
  methods: {
    handleSelect(key) {
      if (key.indexOf('api-') === 0) {
        key = key.substr(4)
        this.mainHtml = apiData[key];
        this.isdebug = true;
        this.activeName = "document";
      }
      else {
        this.mainHtml = data[key];
        this.isdebug = false;
      }
      this.keyName = key;
      window.scrollTo(0, 0);
    }
  },
};
</script>

<style>
.apiDocument {
  background: #f7f7f7;
  overflow: hidden;
}
.apiDocument .e-table .cell {
  text-overflow: inherit;
}
.apiDocument .dev_title {
  padding: 0px 20px;
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 600;
  color: #333333;
  line-height: 46px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(223, 223, 223, 1);
}
.apiDocument .body {
  width: 1200px;
  overflow-y: hidden;
  margin: 30px auto;
}

.apiDocument .el-container {
  height: 100%;
  min-height: 600px;
}

.apiDocument .el-aside {
  background: #ffffff;
  margin-right: 20px;
  min-height: 600px;
}

.apiDocument .el-menu-item,
.dev_title .el-submenu__title,
.apiDocument .el-submenu__title span {
  color: #333333;
  font-weight: 600;
  font-size: 13px;
}
.apiDocument .el-submenu__title span {
  padding-left: 23px;
}
.apiDocument .el-menu-item.is-active {
  border-left: 3px solid #108ee9;
  color: #108ee9;
  background-color: #ecf5ff;
}
.apiDocument .el-collapse-item {
  margin-left: 20px;
}
.apiDocument .el-menu-item {
  border-left: 3px solid white;
  padding-left: 40px !important;
  line-height: 40px;
  height: 40px;
}
.apiDocument .el-menu-item,
.apiDocument .el-submenu__title {
  line-height: 40px;
  height: 40px;
}
.apiDocument .el-submenu {
  line-height: 40px;
}
.apiDocument .el-submenu .el-menu-item {
  padding-left: 80px !important;
}
.apiDocument .el-menu-item:hover {
  border-left: 3px solid #ecf5ff;
}
.apiDocument .el-menu {
  border-right: none;
}

.apiDocument .content-wrapper {
  font-family: "Microsoft Yahei";
  font-size: 14px;
  color: #3a3a3a;
  width: 948px;
  margin: 20px;
}

.apiDocument .cm-s-darcula.CodeMirror {
  height: 500px;
  /* min-height: 400px; */
}

/* .apiDocument .cm-s-darcula.CodeMirror .CodeMirror-scroll{
  min-height: 400px;
} */

.apiDocument .subtitle {
  font-weight: 600;
  font-size: 14px;
}

.apiDocument .content-wrapper .data pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 12px;
  font-family: ArialMT;
  font-weight: 400;
  overflow-y: auto;
  line-height: 1.42857143;
  word-break: break-all;
  word-wrap: break-word;
  color: #666666;
  background-color: #fdfdfd;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.apiDocument .content-wrapper h1 {
  margin-top: 30px;
  margin-bottom: 10px;
}

.apiDocument .my-header-row-class {
  color: #333333;
  font-weight: 600;
}
.newdocumentIntroduce h1 {
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  padding-bottom: 40px;
  margin: 0 0 10px;
  border-bottom: 1px solid #f0f0f0;
  padding-left: 30px;
}
.newdocumentIntroduce p {
  line-height: 30px;
  margin-bottom: 5px;
  text-indent: 2em;
  padding: 0 30px;
}
.content-wrapper th {
  background-color: #e0e0e0;
}

.apiDocument .el-main {
  background-color: #fff;
}
.el-table td,
.el-table th {
  padding: 6px 0;
  font-size: 12px;
}
.el-table th > .cell {
  font-weight: 600;
  color: #424242;
}
.showAutographContent p {
  text-indent: inherit;
  padding: 0;
}
.apiDocument .table-emaple {
  overflow: hidden;
  border: 1px solid rgb(235, 238, 245);
  color: rgb(96, 98, 102);
  border-top: none;
}
.apiDocument .left-tb {
  float: left;
  width: 100px;
  text-align: center;
  border-right: 1px solid #ebeef5;
  line-height: 30px;
  height: 206px;
}
.right-tb {
  float: left;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/front/documentV2/index.vue